export enum PreModifierDisplayMode {
  PREFIX = 'prefix',
  SUFFIX = 'suffix',
}
